import { myAccountLinks } from '@agria/theme-my-account/src/const/myAccountLinks';
import { NavItem } from '@agria/theme-my-account/src/types/types';
import { ctaButtons } from '@agria/theme-my-account/src/const/ctaButtons';

//
// CUSTOMERS
//

export const customerLinks: NavItem[] = [
  {
    label: 'Home',
    url: myAccountLinks.dashboard,
    ctaOverride: ctaButtons.customer,
  },
  {
    label: 'My pets',
    url: myAccountLinks.myPets,
    partiallyActive: true,
    ctaOverride: ctaButtons.customer,
  },
  {
    label: 'My claims',
    url: myAccountLinks.myClaims,
    ctaOverride: ctaButtons.customer,
  },
  {
    label: 'Document hub',
    partiallyActive: true,
    url: myAccountLinks.documentHub,
    ctaOverride: ctaButtons.customer,
  },
  {
    label: 'My details',
    url: myAccountLinks.myDetails,
    ctaOverride: ctaButtons.customer,
  },
  {
    label: 'Access to a vet 24/7',
    url: myAccountLinks.vetGuide,
    ctaOverride: ctaButtons.customer,
  },
  {
    label: 'Help and contact',
    url: myAccountLinks.helpAndContact,
    ctaOverride: ctaButtons.customer,
  },
];

export const vetLinks: NavItem[] = [];

export const nonAffiliateVetLinks: NavItem[] = [];

export const breederLinks: NavItem[] = [];

export const rehomingLinks: NavItem[] = [];
